"use client";
import React from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/Button";
import { useAuth } from "@/context/AuthContext";
// import { saveCurrentUrl } from "@/utils/utils";

const DownloadButton = () => {
  const { sessionUser } = useAuth();
  const router = useRouter();

  const handleDownloadPDF = () => {
    if (!sessionUser?.subscriber_id) {
      // Store the current page URL before redirecting to signup
      // saveCurrentUrl();
      router.push("/auth/login");
      return;
    }
    
    // If user is logged in, proceed with download
    window.open(`${process.env.NEXT_PUBLIC_ASSET_URL}/documents/963cec0f-8449-426d-b0d9-78515f2e025e.pdf`, "_blank");
  };

  return (
    <Button className="self-end whitespace-nowrap w-full lg:w-auto"
    onClick={handleDownloadPDF}
    >
      {/* <Link
        // href=" https://drive.google.com/file/d/1LGcghttxwSB74efXYbrOaty1pSsQTcQf/view?usp=drive_link"
        href="/documents/963cec0f-8449-426d-b0d9-78515f2e025e.pdf"
        target="_blank"
      > */}
        DOWNLOAD SALES DECK
      {/* </Link> */}
    </Button>
  );
};

export default DownloadButton; 